"use strict";

export default class Utils {
	/**
	 * Deploy promise execution
	 * @param  {time} time in milliseconds
	 * @return {Promise}
	 */
	static delay(time) {
		return new Promise((resolve) => {
			setTimeout(resolve, time);
		});
	}

	/**
	 *
	 * @param eventName
	 * @param eventData
	 */
	static fireSparxpresEvent(eventName, eventData) {
		let _CustomEvent = typeof window.CustomEvent === "function" ? window.CustomEvent : _sparxpres.CustomEvent;
		let customEvent = new _CustomEvent(
			eventName,
			{
				"detail": {
					"customData": eventData
				}
			}
		);
		window.dispatchEvent(customEvent);
	}

	/**
	 * Check if finance is valid/enabled
	 * @param loanInfo
	 * @param priceCents
	 * @return {boolean}
	 */
	static isFinanceEnabled(loanInfo = {}, priceCents = 0) {
		const price = Math.ceil(priceCents / 100);
		return loanInfo
			&& loanInfo.loanId > 0
			&& price
			&& price >= loanInfo.minAmount
			&& price <= loanInfo.maxAmount;
	}

	/**
	 * Check if xprespay is valid/enabled
	 * @param loanInfo
	 * @param priceCents
	 * @return {boolean}
	 */
	static isXpresPayEnabled(loanInfo = {}, priceCents = 0) {
		const price = Math.ceil(priceCents / 100);
		return loanInfo
			&& loanInfo.spxCreditEnabled
			&& price
			&& price <= (loanInfo.spxCreditMaximum || 0);
	}

	/**
	 * Log a message if in debug mode
	 * @param debugEnabled
	 * @param msg
	 * @param args
	 */
	static debug(debugEnabled = false, msg = '', ...args) {
		if (debugEnabled) {
			console.debug("SPX debug: " + msg, ...args);
		}
	}

	/**
	 * Log a info message
	 * @param msg
	 * @param args
	 */
	static info(msg = '', ...args) {
		console.info("SPX info: " + msg, ...args);
	}
}